import { i18n } from '~/i18n'

export default function arrayToSentence(
  array: Array<any>,
  givenOptions: {
    separator?: string
    lastSeparator?: string
    react?: boolean
  } | void,
): any {
  if (array.length === 0) return ''
  if (array.length === 1) return array[0]

  const options = {
    separator: i18n.t('support.array.words_connector'),
    lastSeparator: i18n.t('support.array.last_word_connector'),
    react: false,
    ...givenOptions,
  }

  if (options.react) {
    const output = []
    output.push(
      array
        .slice(0, -1)
        .reduce((prev, curr) => [prev, options.separator, curr]),
    )
    output.push(options.lastSeparator)
    output.push(array[array.length - 1])
    return output.reduce((acc, val) => acc.concat(val), [])
  } else {
    return (
      array.slice(0, -1).join(options.separator) +
      options.lastSeparator +
      array[array.length - 1]
    )
  }
}
